module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "date-wrap"
  }, [_c('div', {
    staticClass: "url"
  }, [_vm._v("\n      Drivmedelsguiden.se\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("\n      " + _vm._s(_vm.date) + "\n    ")])]), _vm._v(" "), _c('h1', [_vm._v("Resultat av jämförelse")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ingress"
  }, [_vm._v("\n      Tack för att du använder drivmedelsguiden.se - en tjänst från Volvofinans Bank."), _c('br'), _vm._v("\n      Nedan följer en sammanställning av dina val.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "line"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-006cd778","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/views/printHeader.vue
// module id = 282
// module chunks = 1